export const polygonArrayReducer = (state = [], action) => {
    switch (action.type) {
        case 'polygonArray':
            return action.payload
        default:
            return state
    }
}
export default polygonArrayReducer;